import { S3_IMAGES_JPG_URL, UGLYPOOL_CONTRACT_ADDRESS } from "config/misc";
import { ethers } from "ethers";
import abiRegular from "abi/regulars.json";

export type PoolObject = {
  id: number;
  registry: string;
  registryName?: string;
  logo?: string;
  owner: string;
  ownerENS?: string;
  price: number;
  treasury: number;
  random: boolean;
  nfts: any[];
  fee: number;
};
export async function setApproval(account: any, library: any, registry: any, notifyHash: any, txType: string) {
  const signer = library?.getSigner();
  const nftContract = new ethers.Contract(registry, abiRegular, signer);
  const isApproved = await nftContract.isApprovedForAll(account, UGLYPOOL_CONTRACT_ADDRESS);
  if (!isApproved) {
    try {
      const tx = await nftContract.setApprovalForAll(UGLYPOOL_CONTRACT_ADDRESS, true);
      notifyHash(tx.hash, txType);
      return 1;
    } catch (e) {
      console.log(e);
    }
  }
  return 0;
}

export function getS3ImageByTokenId(tokenId: number) {
  return `${S3_IMAGES_JPG_URL}${tokenId}?alt=media`;
}
